
import Banner from './common/Banner.vue';
import SectionHeader from './common/SectionHeader.vue';

export default {
  name: 'MeatPageWhy',
  components: { SectionHeader, Banner },
  props: {
    data: {
      type: Object,
      required: true
    },
    common: {
        type: Object,
        default: () => ({})
    }
  }
}
